module.exports = __webpack_public_path__ + "img/sSoccerK_350x350.5a063530.jpg";